import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";

function RelatedCard({ item }) {
  return (
    <div className="custom-relatedblog-card">

      {/* IMAGE */}
      <Link
        to={`/blog/${item?.slug}`}
        className="custom-relatedblog-img"
      >
        <img
          src={item?.image}
          alt={item?.title || "Related blog"}
        />

        <span className="custom-relatedblog-img-arrow">
          ↗
        </span>
      </Link>


      {/* CONTENT */}
      <div className="custom-relatedblog-content">

        {/* DATE */}
        {item?.createdAt && (
          <div className="custom-relatedblog-meta">
            <span className="custom-relatedblog-dot"></span>

            {getDateAgo(item.createdAt)}
          </div>
        )}


        {/* TITLE */}
        <Link
          to={`/blog/${item?.slug}`}
          className="custom-relatedblog-title"
        >
          {item?.title}
        </Link>


        {/* DESCRIPTION */}
        {item?.shortDescription && (
          <p className="custom-relatedblog-desc">
            {item.shortDescription}
          </p>
        )}


        {/* READ MORE */}
        <Link
          to={`/blog/${item?.slug}`}
          className="custom-relatedblog-read"
        >
          <span>Read article</span>

          <span className="custom-relatedblog-read-arrow">
            →
          </span>
        </Link>

      </div>

    </div>
  );
}

export default RelatedCard;